import Vue from 'vue'
import { required, email, max, min } from "vee-validate/dist/rules";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

let PhoneNumber = require( 'awesome-phonenumber' );

extend('phone', {
    message (fieldName) {
        return `${fieldName} is not a valid phone number`;
    },
    validate (value) {
        return new Promise(resolve => {
            let phone = new PhoneNumber(value);
            resolve({ valid: phone.isValid() })
        });
    }
});

extend("required", {
    ...required,
    message: "This field is required"
});

extend("max", {
    ...max,
    message: "This field must be {length} characters or less"
});

extend("min", {
    ...min,
    message: "This field must be {length} characters or more"
});

extend("email", {
    ...email,
    message: "This field must be a valid email"
});
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);